import isFunction from 'lodash/isFunction';
import omitBy from 'lodash/omitBy';

/**
 * Returns a shallow copy of the given state without computed properties or functions.
 */
export const extractInitialState = <T>(state: T): T => {
  return omitBy(
    state as object,
    (value, key): boolean => isFunction(value) || key === 'computed',
  ) as T;
};
